module.exports = __webpack_public_path__ + "fonts/Norhli_Logo_White.svg";